import React, { useState } from 'react'
import { Printer } from 'lucide-react'
import PrintDialog from './PrintDialog'

interface PrintButtonProps {
  entityType: 'item' | 'location' | 'shelf' | 'tote'
  entityData: any
  categoryId?: string
  variant?: 'icon' | 'button' | 'compact'
  label?: string
}

export default function PrintButton({
  entityType,
  entityData,
  categoryId,
  variant = 'button',
  label = 'Print Label'
}: PrintButtonProps) {
  const [showDialog, setShowDialog] = useState(false)

  if (variant === 'icon') {
    return (
      <>
        <button
          onClick={() => setShowDialog(true)}
          style={{
            background: 'rgba(0, 240, 255, 0.1)',
            border: '1px solid rgba(0, 240, 255, 0.3)',
            borderRadius: '6px',
            padding: '8px',
            cursor: 'pointer',
            transition: 'all 0.2s',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = 'rgba(0, 240, 255, 0.2)'
            e.currentTarget.style.borderColor = 'rgba(0, 240, 255, 0.5)'
            e.currentTarget.style.boxShadow = '0 0 15px rgba(0, 240, 255, 0.4)'
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = 'rgba(0, 240, 255, 0.1)'
            e.currentTarget.style.borderColor = 'rgba(0, 240, 255, 0.3)'
            e.currentTarget.style.boxShadow = 'none'
          }}
          title="Print Label"
        >
          <Printer style={{ width: '16px', height: '16px', color: '#00F0FF' }} />
        </button>

        <PrintDialog
          isOpen={showDialog}
          onClose={() => setShowDialog(false)}
          entityType={entityType}
          entityData={entityData}
          categoryId={categoryId}
        />
      </>
    )
  }

  if (variant === 'compact') {
    return (
      <>
        <button
          onClick={() => setShowDialog(true)}
          style={{
            padding: '8px 16px',
            background: 'linear-gradient(135deg, rgba(0, 240, 255, 0.2), rgba(0, 184, 212, 0.2))',
            border: '2px solid rgba(0, 240, 255, 0.4)',
            borderRadius: '6px',
            color: '#00F0FF',
            fontSize: '0.875rem',
            fontWeight: 600,
            cursor: 'pointer',
            transition: 'all 0.2s',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            fontFamily: 'Rajdhani, sans-serif',
            textTransform: 'uppercase',
            letterSpacing: '0.5px'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = 'linear-gradient(135deg, rgba(0, 240, 255, 0.3), rgba(0, 184, 212, 0.3))'
            e.currentTarget.style.borderColor = 'rgba(0, 240, 255, 0.6)'
            e.currentTarget.style.boxShadow = '0 0 15px rgba(0, 240, 255, 0.4)'
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = 'linear-gradient(135deg, rgba(0, 240, 255, 0.2), rgba(0, 184, 212, 0.2))'
            e.currentTarget.style.borderColor = 'rgba(0, 240, 255, 0.4)'
            e.currentTarget.style.boxShadow = 'none'
          }}
        >
          <Printer style={{ width: '16px', height: '16px' }} />
          {label}
        </button>

        <PrintDialog
          isOpen={showDialog}
          onClose={() => setShowDialog(false)}
          entityType={entityType}
          entityData={entityData}
          categoryId={categoryId}
        />
      </>
    )
  }

  // Default button variant
  return (
    <>
      <button
        onClick={() => setShowDialog(true)}
        style={{
          padding: '12px 24px',
          background: 'linear-gradient(135deg, #00F0FF, #00B8D4)',
          border: '2px solid rgba(0, 240, 255, 0.6)',
          borderRadius: '8px',
          color: '#FFFFFF',
          fontSize: '0.875rem',
          fontWeight: 700,
          textTransform: 'uppercase',
          letterSpacing: '1px',
          cursor: 'pointer',
          transition: 'all 0.2s',
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          fontFamily: 'Rajdhani, sans-serif',
          boxShadow: '0 0 20px rgba(0, 240, 255, 0.4)'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.boxShadow = '0 0 30px rgba(0, 240, 255, 0.6)'
          e.currentTarget.style.transform = 'scale(1.02)'
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.boxShadow = '0 0 20px rgba(0, 240, 255, 0.4)'
          e.currentTarget.style.transform = 'scale(1)'
        }}
      >
        <Printer style={{ width: '18px', height: '18px' }} />
        {label}
      </button>

      <PrintDialog
        isOpen={showDialog}
        onClose={() => setShowDialog(false)}
        entityType={entityType}
        entityData={entityData}
        categoryId={categoryId}
      />
    </>
  )
}
